module.exports = __webpack_public_path__ + "static/autognome-b5c3d2733daa4d2eeebb6dc4a8b76560.webp";